import type { ISecrEnergySourceLine } from '../../../../shared/services/generated-report/generated-report.model';

/**
 * Which metrics apply to which SECR source keys for display (0 vs –).
 * Scope 1: fuel / combustion sources.
 * Scope 2 (location & market): electricity and purchased energy only.
 */

export type SecrSourceMetricField = 'energyKwh' | 'scope1Tco2e' | 'scope2LocationTco2e' | 'scope2MarketTco2e';

const FUEL_SCOPE1_KEYS = new Set([
  'natural_gas',
  'diesel',
  'petrol',
  'lpg',
  'other_fuel',
  'other_energy',
  'unmapped',
]);

const SCOPE2_KEYS = new Set(['electricity', 'purchased_heat', 'purchased_steam', 'purchased_cooling']);

export function isScope1ApplicableForSourceKey(sourceKey: string): boolean {
  return FUEL_SCOPE1_KEYS.has(sourceKey);
}

export function isScope2ApplicableForSourceKey(sourceKey: string): boolean {
  return SCOPE2_KEYS.has(sourceKey);
}

export function isEnergyApplicableForSourceKey(_sourceKey: string): boolean {
  return true;
}

export function isMetricApplicableForSourceKey(sourceKey: string, field: SecrSourceMetricField): boolean {
  switch (field) {
    case 'energyKwh':
      return isEnergyApplicableForSourceKey(sourceKey);
    case 'scope1Tco2e':
      return isScope1ApplicableForSourceKey(sourceKey);
    case 'scope2LocationTco2e':
    case 'scope2MarketTco2e':
      return isScope2ApplicableForSourceKey(sourceKey);
    default:
      return false;
  }
}

/** Total row: column has a value only if at least one data row uses that metric. */
export function isTotalMetricApplicable(dataLines: ISecrEnergySourceLine[], field: SecrSourceMetricField): boolean {
  return dataLines.some((l) => isMetricApplicableForSourceKey(l.key, field));
}
